// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyExperiences_faculty-detail-experiences__-3O2D {
  position: relative;
}
.FacultyExperiences_faculty-detail-experiences__-3O2D .FacultyExperiences_faculty-detail-experiences-landscape__gnjUF {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin-top: 15px;
}
.FacultyExperiences_faculty-detail-experiences__-3O2D .FacultyExperiences_faculty-detail-experiences-landscape__gnjUF .FacultyExperiences_list-experiences-title__9bVZ\\+ {
  margin-bottom: 12px !important;
  display: flex;
  align-items: center;
}
.FacultyExperiences_faculty-detail-experiences__-3O2D .FacultyExperiences_faculty-detail-experiences-landscape__gnjUF .FacultyExperiences_list-experiences-title__9bVZ\\+ .FacultyExperiences_title__vsNV8 {
  font-weight: bold;
  font-size: 16px;
  margin-right: 15px !important;
}
.FacultyExperiences_faculty-detail-experiences__-3O2D .FacultyExperiences_faculty-detail-experiences-landscape__gnjUF .FacultyExperiences_see-more__Ez4tp {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.FacultyExperiences_faculty-detail-experiences__-3O2D .FacultyExperiences_faculty-detail-experiences-landscape__gnjUF .FacultyExperiences_see-more__Ez4tp p {
  cursor: pointer;
  color: var(--explore-color);
  font-size: 14px;
}
.FacultyExperiences_faculty-detail-experiences__-3O2D .FacultyExperiences_faculty-detail-experiences-mobile__r-k1k {
  display: none;
}
@media only screen and (max-width: 900px) {
  .FacultyExperiences_faculty-detail-experiences__-3O2D .FacultyExperiences_faculty-detail-experiences-landscape__gnjUF {
    display: none !important;
  }
  .FacultyExperiences_faculty-detail-experiences__-3O2D .FacultyExperiences_faculty-detail-experiences-mobile__r-k1k {
    display: block;
  }
}

.FacultyExperiences_experience__\\+hz5R {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.FacultyExperiences_experience__\\+hz5R .FacultyExperiences_experience-info__nAoW1 {
  font-size: 14px;
}
.FacultyExperiences_experience__\\+hz5R .FacultyExperiences_experience-info__nAoW1 span {
  font-size: 14px;
}
.FacultyExperiences_experience__\\+hz5R .FacultyExperiences_experience-info__nAoW1 .FacultyExperiences_title__vsNV8 {
  display: flex;
  align-items: flex-start;
}
.FacultyExperiences_experience__\\+hz5R .FacultyExperiences_experience-info__nAoW1 .FacultyExperiences_title__vsNV8 .anticon {
  margin-top: 2px;
}
.FacultyExperiences_experience__\\+hz5R .FacultyExperiences_experience-info__nAoW1 .FacultyExperiences_title__vsNV8 .FacultyExperiences_information__HOHQd {
  margin-left: 10px;
}
.FacultyExperiences_experience__\\+hz5R .FacultyExperiences_experience-info__nAoW1 .FacultyExperiences_title__vsNV8 .FacultyExperiences_information__HOHQd .FacultyExperiences_inst-name__XEU3a:hover {
  color: var(--blue);
  cursor: pointer;
  text-decoration: underline;
}
.FacultyExperiences_experience__\\+hz5R .FacultyExperiences_experience-info__nAoW1 .FacultyExperiences_title__vsNV8 .FacultyExperiences_information__HOHQd .FacultyExperiences_sub-title__8XUet {
  color: var(--dark-grey);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/FacultyExperiences/FacultyExperiences.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAEJ;AADI;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AAGN;AAFM;EACE,iBAAA;EACA,eAAA;EACA,6BAAA;AAIR;AADI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAGN;AAFM;EACE,eAAA;EACA,2BAAA;EACA,eAAA;AAIR;AAAE;EACE,aAAA;AAEJ;AAAE;EACE;IACE,wBAAA;EAEJ;EAAE;IACE,cAAA;EAEJ;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAEF;AADE;EACE,eAAA;AAGJ;AAFI;EACE,eAAA;AAIN;AAFI;EACE,aAAA;EACA,uBAAA;AAIN;AAHM;EACE,eAAA;AAKR;AAHM;EACE,iBAAA;AAKR;AAFU;EACE,kBAAA;EACA,eAAA;EACA,0BAAA;AAIZ;AADQ;EACE,uBAAA;AAGV","sourcesContent":[".faculty-detail-experiences {\n  position: relative;\n  .faculty-detail-experiences-landscape {\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    padding: 20px;\n    margin-top: 15px;\n    .list-experiences-title {\n      margin-bottom: 12px !important;\n      display: flex;\n      align-items: center;\n      .title {\n        font-weight: bold;\n        font-size: 16px;\n        margin-right: 15px !important;\n      }\n    }\n    .see-more {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      p {\n        cursor: pointer;\n        color: var(--explore-color);\n        font-size: 14px;\n      }\n    }\n  }\n  .faculty-detail-experiences-mobile {\n    display: none;\n  }\n  @media only screen and (max-width: 900px) {\n    .faculty-detail-experiences-landscape {\n      display: none !important;\n    }\n    .faculty-detail-experiences-mobile {\n      display: block;\n    }\n  }\n}\n.experience {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  .experience-info {\n    font-size: 14px;\n    span {\n      font-size: 14px;\n    }\n    .title {\n      display: flex;\n      align-items: flex-start;\n      :global(.anticon) {\n        margin-top: 2px;\n      }\n      .information {\n        margin-left: 10px;\n\n        .inst-name {\n          &:hover {\n            color: var(--blue);\n            cursor: pointer;\n            text-decoration: underline;\n          }\n        }\n        .sub-title {\n          color: var(--dark-grey);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-detail-experiences": `FacultyExperiences_faculty-detail-experiences__-3O2D`,
	"faculty-detail-experiences-landscape": `FacultyExperiences_faculty-detail-experiences-landscape__gnjUF`,
	"list-experiences-title": `FacultyExperiences_list-experiences-title__9bVZ+`,
	"title": `FacultyExperiences_title__vsNV8`,
	"see-more": `FacultyExperiences_see-more__Ez4tp`,
	"faculty-detail-experiences-mobile": `FacultyExperiences_faculty-detail-experiences-mobile__r-k1k`,
	"experience": `FacultyExperiences_experience__+hz5R`,
	"experience-info": `FacultyExperiences_experience-info__nAoW1`,
	"information": `FacultyExperiences_information__HOHQd`,
	"inst-name": `FacultyExperiences_inst-name__XEU3a`,
	"sub-title": `FacultyExperiences_sub-title__8XUet`
};
export default ___CSS_LOADER_EXPORT___;
